import { useCallback, useEffect, useState } from 'react';
import { ITEMS_PER_PAGE } from 'utils/utils';

export default function useLocalSearch({ payload, itemsPerPage = ITEMS_PER_PAGE }) {
    const [fullData, setFullData] = useState([]);
    const [data, setData] = useState([]);
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        setFullData(payload || []);
        setItemOffset(0); 
    }, [payload]);

    const onSearch = useCallback(
        (letters) => {
            if (!letters) {
                setFullData(payload || []);
                return;
            }

            const result = (payload || []).filter((item) =>
                item.name.match(new RegExp(letters, 'i')),
            );

            setFullData(result);
            setItemOffset(0);  
        },
        [payload],
    );

    useEffect(() => {
        if (!fullData) return;

        const start = itemOffset;
        const end = itemOffset + itemsPerPage;

        setData(fullData.slice(start, end));
    }, [fullData, itemOffset, itemsPerPage]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % fullData.length;
        setItemOffset(newOffset);
    };

    return { onSearch, data, handlePageClick, fullData };
}
